import { useEffect, useState, useContext } from "react";
import { ManifestoInterface as iData } from "../../interfaces";
import manifestoService from "../../services/ManifestoService";
import { Col, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp, faCheck, faPencil, faPrint, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { JAlerta, JCaption, JCard, JCardBody, JConfirmDelete, JHeader, JPaginacao, JTable, JTBody, JTHead, PdfModal } from "../../components/Components";
import { AuthContext } from "../../contexts/AuthContext";
import { navigateTo } from "../../utils/navigation";
import { BASE_URL } from "../../api/api";

const initial = {
    id: "",
    ufini: "",
    uffim: "",
    nmdf: 0,
    chave: "",
    protocolo: "",
    modal: "",
    tptransp: "",
    dhemi: "",
    infocompl: "",
    dhcancel: "",
    dhencer: "",
    situacao: "",
    code_situacao: 1,
};

export default function IndexManifesto() {
    const [dados, setDados] = useState<iData[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<iData>(initial);
    const [showSpinner, setShowSpinner] = useState<boolean>(true);
    const [showError, setShowError] = useState<boolean>(false);
    const [showMessageError, setShowMessageError] = useState<string>('');
    const [search, setSearch] = useState<string>('');
    const [meta, setMeta] = useState<any>(null)
    const [links, setLinks] = useState<any>(null)
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);
    const [typeMessage, setTypeMessage] = useState<string>('danger');
    const [showPdf, setShowPdf] = useState<boolean>(false);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Insert') {
            navigate('/manifesto/create');
        }
    }

    const handleOpenPdf = async (id:  string) => {
        await manifestoService.damdfe(id).then(res => {
            
            const file = new Blob([res], {type: 'application/pdf'});
            const url =  URL.createObjectURL(file);

            setPdfUrl(url); 
            setShowPdf(true);

        }).catch(err => {
            setShowError(true);
            setShowMessageError('Error ao carregar DAMDFE');
            setTypeMessage('danger');
        });
      };

    const searchFilter = (page: string | null = null) => {

        setShowSpinner(true);

        manifestoService.getAllPaginate(search, page).then(response => {
            setDados(response.data);
            setLinks(response.links);
            setMeta(response.meta);
            setShowSpinner(false);

        }).catch(err => {
            setShowSpinner(false);

        });

    }

    const handleClose = () => {
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
          setPdfUrl(null);
        }
        setShowPdf(false);
      };

    const handleDelete = (id: string) => {

        manifestoService.delete(id).then(data => {
            setDados(dados.filter(data => data.id !== id));
            setShowModal(false);
            setShowError(true);
            setShowMessageError('Manifesto removido com sucesso');
            setTypeMessage('success');

        }).catch(err => {
            const error400 = [403, 400]

            if (error400.includes(err.response.status)) {
                setShowModal(false);
                setShowError(true)
                setShowMessageError(err.response.data.message)
                setTypeMessage('danger');
            }
        });
    }


    const handlePageChange = (page: string | null = null) => {
        searchFilter(page)
    }

    const handleOpenModal = (conta: any) => {
        setSelected(conta);
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initial);
    }

    const handleEditarManifesto = (id: number | string) => {
        manifestoService.get(id.toString()).then(() => {
            navigate(`/manifesto/${id}`)
        }).catch(error => {
            setShowError(true);
            setShowMessageError(error.response.data.message);
        })
    }

    const handleTransmitir = async (id: number | string) => {
       await manifestoService.transmitir(id.toString()).then((res) => {

            setDados((prev) => prev.map((item) =>
                item.id === id ? {
                    ...item,
                    situacao: res.data.situacao,
                    code_situacao: res.data.code_situacao,
                    chave: res.data.chave,
                    dhemi: res.data.dhemi
                } : item)
            );


            setShowError(true);
            setShowMessageError(res.message);
            setTypeMessage('success');

        }).catch(error => {
            setShowError(true);
            setShowMessageError(error.response.data.message);

        })
    }

    const handleEncerrar = async (id: number | string) => {

        await manifestoService.encerrar(id.toString()).then((res) => {
            setDados((prev) => prev.map((item) =>
                item.id === id ? {
                    ...item,
                    situacao: res.data.situacao,
                    code_situacao: res.data.code_situacao,
                    chave: res.data.chave,
                    dhemi: res.data.dhemi
                } : item)
            );

            setShowError(true);
            setShowMessageError(res.message);
            setTypeMessage('success');

        }).catch(error => {
            setShowError(true);
            setShowMessageError(error.response.data.message);

        })
    }

    const handleCancelar = async (id: number | string) => {

        await manifestoService.cancelar(id.toString()).then((res) => {
            setDados((prev) => prev.map((item) =>
                item.id === id ? {
                    ...item,
                    situacao: res.data.situacao,
                    code_situacao: res.data.code_situacao,
                    chave: res.data.chave,
                    dhemi: res.data.dhemi
                } : item)
            );

            setShowError(true);
            setShowMessageError(res.message);
            setTypeMessage('success');

        }).catch(error => {
            setShowError(true);
            setShowMessageError(error.response.data.message);

        })
    }

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown)
        searchFilter();

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [search]);

    return (
        <>
            <JAlerta showError={showError} close={setShowError} messageError={showMessageError} variant={typeMessage} />
            <div className="row d-flex justify-content-between align-items-start g-2">
                <Col md>
                    <JCard >
                        <JHeader
                            urlCreate="/manifesto/create"
                            search={search}

                            setSearch={setSearch}
                            showSpinner={showSpinner}
                            permissionCreate={authContext?.checkPermission('manifesto_create')}
                            permissionSearch={authContext?.checkPermission('manifesto_search')}
                        />
                        <JCardBody>
                            <JCaption>
                                Lista de Manifestos
                                <JPaginacao
                                    links={links ?? {}}
                                    meta={meta ?? {}}
                                    handlePageChange={handlePageChange} />
                            </JCaption>
                            <JTable >

                                <JTHead>

                                    <tr>
                                        <th style={{ width: '5rem' }} className="text-center">Ações</th>
                                        <th style={{ width: '7rem' }}>
                                            Número
                                        </th>
                                        <th style={{ width: '11rem' }}>Data de Emissão</th>
                                        <th style={{ width: '5rem' }}>UF Ini.</th>
                                        <th style={{ width: '5rem' }}>UF Fim</th>
                                        <th  >Chave</th>
                                        <th style={{ width: '17rem' }} >Modal</th>

                                        <th style={{ width: '17rem' }} className="text-center">
                                            Situação
                                        </th>

                                    </tr>
                                </JTHead>
                                <JTBody>
                                    {dados?.map((data) => (
                                        <tr key={data.id}>
                                            <td className="text-center">

                                                <Dropdown className="d-grid gap-2" >
                                                    <Dropdown.Toggle variant="primary" id="dropdown-basic" size="sm">
                                                        MDF-e
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        {data.code_situacao !== 1 && (

                                                            <Dropdown.Item as={Link} to={``} onClick={() => handleOpenPdf(data.id)} > <FontAwesomeIcon icon={faPrint} className="text-primary" /> DAMDF-e</Dropdown.Item>
                                                        )}

                                                        {data.code_situacao === 2 && (
                                                            <>
                                                                <Dropdown.Item as={Link} to={``} onClick={() => handleEncerrar(data.id)}> <FontAwesomeIcon icon={faCheck} className="text-success" /> Encerrar</Dropdown.Item>
                                                                <Dropdown.Item as={Link} to={``} onClick={() => handleCancelar(data.id)}> <FontAwesomeIcon icon={faXmark} className="text-danger" /> Cancelar</Dropdown.Item>

                                                            </>
                                                        )


                                                        }

                                                        {data.code_situacao === 1 && (
                                                            <>
                                                                <Dropdown.Item as={Link} to={``} onClick={() => handleEditarManifesto(data.id)} > <FontAwesomeIcon icon={faPencil} className="text-primary" /> Editar</Dropdown.Item>
                                                                <Dropdown.Item as={Link} to={``} onClick={() => handleOpenModal(data)}> <FontAwesomeIcon icon={faTrash} className="text-danger" /> Remover</Dropdown.Item>
                                                                <Dropdown.Item as={Link} to={``} onClick={() => handleTransmitir(data.id)}  > <FontAwesomeIcon icon={faArrowUp} className="text-success" /> Transmitir</Dropdown.Item>

                                                            </>
                                                        )}



                                                    </Dropdown.Menu>
                                                </Dropdown>



                                                {/* <Link className="text-primary" to={`/manifesto/${data.id}`}>
                                                    <FontAwesomeIcon icon={faPencil} />
                                                </Link>
                                                <button type="button" onClick={() => handleOpenModal(data)} 
                                                    className="text-danger ms-2" 
                                                    style={{ border: 'none', background: 'none', padding: '0', cursor: 'pointer' }}>
                                                        <FontAwesomeIcon icon={faTrash}/>
                                                </button> */}
                                            </td>
                                            <td>{data.nmdf}</td>
                                            <td>{data.dhemi}</td>
                                            <td>{data.ufini}</td>
                                            <td>{data.uffim}</td>
                                            <td>{data.chave}</td>
                                            <td>{data.modal}</td>
                                            <td className="text-center">{data.situacao}</td>


                                        </tr>
                                    ))}
                                </JTBody>
                            </JTable>
                        </JCardBody>
                    </JCard>
                </Col>
            </div>

            <JConfirmDelete
                showModal={showModal}
                handleCloseModal={handleCloseModal}
                handleDelete={handleDelete}
                selectedObject={selected?.nmdf}
                id={selected?.id}
            />

            <PdfModal show={showPdf} onHide={handleClose} pdfUrl={pdfUrl} />

        </>
    );
};

